<template>
<div>
    
    <div class="app-content content devcontent ">
        <div class="content-overlay"></div>
        <div class="header-navbar-shadow"></div>
        <div class="content-wrapper">
            <div class="content-header-left mb-1 pt-0 pad_top_mar_bot-5">
                <div class="container-fluid">
                   <div class="row breadcrumbs-top">
                      <div class="col-md-12 content-header-left px-0">
                        <h3 class="content-header-title float-left mb-0" >Escalation   </h3>
                        <div class="breadcrumb-wrapper">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><router-link to='/mydashboard'> TAT Configuration</router-link>
                                </li>
                                
                               
                                
                            </ol>
                        </div>
                        
                      </div>
                   </div>
                </div>
                
            </div>
            <div class="content-body">
                <vue-element-loading :active="isLoading"  :is-full-screen="true"/>
                <section>
            <div class="card">
              <div class="card-header px-0 common_top_title_searchbgst_dock">
                <div class="container-fluid">
                  <div class="row row fc_my-05">
                    <div class="w-auto px-1 mobile-padding-0-2">
                      <div
                        class="avatar bg-light-secondary rounded d-inline-flex mr-1"
                      >
                        <div class="avatar-content">
                          <em
                            class="i_icon_st la-chalkboard las lab font-medium-5"
                          ></em>
                        </div>
                      </div>
                      <h4 class="card-title d-inline-flex ml-0 mb-0">
                        Escalation TAT Configuration
                      </h4>
                    </div>
                  </div>
                </div>
              </div>

              <div class="container-fluid pt-1 pb-2">
                <div class="row mx-0 contains">
                  <div
                    class="col-12 col-sm-6 col-md-6 col-lg-3 mb-1 mobileview_b_8"
                  >
                    <label class="form-label text-left w-100"
                      >Scenario<span class="requiredField">*</span></label
                    >
                    <treeselect
                      placeholder="Select scenario"
                      v-model="formData.scenario"
                      :options="scenarios"
                      @input="handleScenarioChange"
                    />
                  </div>

                  <div
                    v-if="is_level_applicable"
                    class="col-12 col-sm-6 col-md-6 col-lg-3 mb-1 mobileview_b_8"
                  >
                    <label class="form-label text-left w-100">Level</label>
                    <treeselect
                      :clearable="false"
                      placeholder="Select Escalation level"
                      v-model="formData.level"
                      :options="escalationlevel"
                      @input="handleLevelChange"
                    />
                  </div>
                  <template
                    v-if="is_level_applicable"
                    class="row"
                    v-for="(level, index) in formData.level"
                  >
                    <div
                      class="col-12 col-sm-6 col-md-6 col-lg-3 mb-1 expected_Datevieww100"
                      :key="index"
                    >
                      <label
                        for="expected_duration"
                        class="form-label text-left w-100"
                      >
                        Time for Level {{ index + 1 }}</label
                      >
                      <vue-timepicker
                        name="expected_duration"
                        class="appmdldesc_input-100"
                        type="time"
                        id="qahours"
                        format="HH:mm"
                        v-model="formData.escalationlevel[index].time"
                        :minute-interval="10"
                        :hour-range="[[0, 23]]"
                      ></vue-timepicker>
                    </div>

                    <div
                      class="col-12 col-sm-6 col-md-6 col-lg-3 mb-1 mobileview_b_8"
                    >
                      <label class="form-label text-left w-100"
                        >Call Receivers for level {{ index + 1 }}</label
                      >

                      <treeselect
                        placeholder="Select Call Receivers"
                        v-model="formData.escalationlevel[index].callreceivers"
                        :options="allcallreceivers"
                        multiple
                      />
                    </div>
                  </template>
                  <template v-else>
                    <div
                      class="col-12 col-sm-6 col-md-6 col-lg-3 mb-1 mobileview_b_8"
                    >
                      <label class="form-label text-left w-100"
                        >Subscribers</label
                      >
                      <treeselect
                        placeholder="Select Staff"
                        :options="staffs"
                        v-model="formData.subscribers"
                        multiple
                      />
                    </div>
                    <div
                      class="col-12 col-sm-6 col-md-6 col-lg-3 mobileview_b_8"
                    >
                      <label for="file">Upload Subscriber Contacts</label>
                      <input
                        type="file"
                        id="file"
                        name="file"
                        accept=".xlsx, .xls, .csv"
                        @change="onSelectDoc($event)"
                      />
                      <download-icon
                        v-b-tooltip.hover
                        title="Download Template"
                        size="1.5x"
                        class="file-icon avatar-icon font-medium-2 mr-50"
                        @click="handleDownloadClick"
                      ></download-icon>
                    </div>
                    <div
                      class="col-12 col-sm-6 col-md-6 col-lg-3 mb-1 mobileview_b_8"
                    >
                      <label class="form-label text-left w-100"
                        >Call Scheduled At<span class="requiredField"
                          >*</span
                        ></label
                      >
                      <date-picker
                        placeholder="Select date and time "
                        v-model="formData.call_time"
                        format="'YYYY-MM-DD  HH:mm'"
                        type="datetime"
                        :minute-step="5"
                        class="startdate w-100"
                        :disabled-date="disabledPastDates"
                        :disabled-time="disabledPastTime"
                      ></date-picker>
                    </div>
                    <div
                      class="col-12 col-sm-6 col-md-6 col-lg-6 mb-1 mobileview_b_8"
                    >
                      <label class="form-label text-left w-100"
                        >Announcement Message<span class="requiredField"
                          >*</span
                        ></label
                      >
                      <b-form-textarea
                        id="textarea"
                        v-model="formData.announcement_message"
                        placeholder="Enter meessage text which will be announced via call"
                        rows="3"
                        max-rows="6"
                      ></b-form-textarea>
                    </div>
                  </template>
                  <div
                    class="pull-right text-right col-12 col-sm-12 col-md-12 col-lg-12 px-0"
                  >
                    <button
                      type="button"
                      class="btn btn-relief-primary common-btn_btn_view"
                      style="margin-top: 18px !important"
                      @click="saveDataOn"
                      :disabled="!validateForm()"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from "axios"
import moment from "moment";
import Pagination from 'vue-pagination-2'
import DatePicker from 'vue2-datepicker';
import VueTimepicker from "vue2-timepicker";
import 'vue2-datepicker/index.css'
import Treeselect from '@riophae/vue-treeselect'
import VueElementLoading from 'vue-element-loading'
import { XCircleIcon, FileIcon, UploadIcon, DownloadIcon, EditIcon } from 'vue-feather-icons';
import CONSTANT from "../constants.js"
import { read, utils } from "xlsx";
import schema from "../utils/schema";
import common_methods from "../utils/common_methods"
import searchMasterNameList from "../utils/searchMasterNameList"

export default{
    name:'escalationConfiguration',
    mixins: [ common_methods, searchMasterNameList ],
    components: {
        Treeselect,
        DatePicker,
        VueTimepicker,
        VueElementLoading,
        Pagination,
        UploadIcon,
        FileIcon,
        XCircleIcon,
        DownloadIcon,
        EditIcon,
        Pagination,
    },
    data() {
    return {
      un: "",
      isLoading: false,
      istimeCorrect: false,
      masterUploadName: "subscribers",
      master: {
        warehouse_master: {
          url: "",
          list: [],
          totalcount: 0,
          pageCount: 0,
          page: 1,
          pagelimit: CONSTANT.LIMIT,
          currPageNum: 0,
          pageoffset: 1,
          presignedUrls: [],
        },
      },
      //
      scenarios: [],
      is_level_applicable: false,
      escalationlevel: [
        { id: 1, label: "One" },
        { id: 2, label: "Two" },
        { id: 3, label: "Three" },
        { id: 4, label: "Four" },
      ],
      allcallreceivers: [],
      action_time: null,
      hour_list: [],
      minute_list: [],
      staffs: [],
      formData: {
        scenario: null,
        level: 1,
        escalationlevel: [
          {
            time: null,
            callreceivers: [],
          },
          {
            time: null,
            callreceivers: [],
          },
          {
            time: null,
            callreceivers: [],
          },
          {
            time: null,
            callreceivers: [],
          },
        ],
        subscribers: null,
        call_time: null,
        file: null,
        sheetSubscribers: [],
        isValidated: false,
        announcement_message: null,
      },
    };
  },
  mounted() {
    //this.getscenariosOptions()
    //this.getTrackingDashboardCounts()
    // this.loadtimeList();
  },
  created() {
    this.getscenarioList();
    this.getCallReceviers();
    this.getStaffs();
  },
  methods: {
    handleDownloadClick() {
      let headers = [
        {
          "Contact Name": "",
          "Contact Number": "",
        },
      ];
      let fileName = "subscribers_contacts";
      this.getTemplate(headers, fileName);
    },
    goBack() {
      this.$router.go(-1);
    },
    disabledPastTime(time) {
      let dayBefore = moment().format("YYYY-MM-DD HH:mm");
      const beforeToday = new Date(dayBefore);
      return time < beforeToday;
    },
    resetTemplateFileUploadData() {
      this.formData.file = null;
      this.formData.sheetSubscribers = [];
      this.formData.isValidated = false;
      $('input[type="file"]').val("");
    },
    onSelectDoc(event) {
      let currFile = event.target.files[0];
      this.formData.file = currFile;
      let fileName = currFile.name;
      let masterUploadName = this.masterUploadName;
      //$('input[type="file"]').val("");

      const callSnackbarDisplay = (error, type) =>
        this.sweetAlertSnackbar(error, type);
      const assignBulkUploadPayload = (payload) =>
        (this.formData.sheetSubscribers = payload);
      const assignIsValidated = (val) => {
        this.formData.isValidated = val;
        if (!val) {
          this.resetTemplateFileUploadData();
        }
      };

      if (currFile.size > 1024 * 1024 * 25) {
        this.sweetAlertSnackbar(
          "Document of size above 25MB is not allowed",
          "error"
        );
        return;
      }
      var reader = new FileReader();
      reader.readAsArrayBuffer(currFile);
      let getColumnList = this.getColumnList;
      reader.onload = function (e) {
        var data = new Uint8Array(e.target.result);
        var workbook = read(data, {
          type: "array",
          cellDates: true,
          raw: false,
          dateNF: "dd-mm-yyyy",
        });
        let sheetName = workbook.SheetNames[0];
        /* DO SOMETHING WITH workbook HERE */
        let worksheet = workbook.Sheets[sheetName];
        let readData = utils.sheet_to_json(worksheet);
        console.log(readData);
        console.log(schema, "++++++")
         console.log(schema[masterUploadName], "++++++")
        const { value, error } = schema[masterUploadName].validate(
          readData,
          schema.validationOptions
        );
        if (error) {
          let message =
            "ValidationError: Some fields were invalidated. Please fill the data properly and choose the file again.";
          if (error?.details) {
            message = error?.details[0].message.slice(0, 300);
          }
          callSnackbarDisplay(message, "error");
          assignIsValidated(false);
        } else {
          callSnackbarDisplay(
            "Fields Validated, Click Upload button to save Attributes",
            "success"
          );
          let columns = getColumnList(masterUploadName);
          let payload = value.map((item) => {
            let obj = {};
            columns.forEach((col) => {
              if (col.format) {
                obj[col.id] = col.format(item[col.label]);
              } else {
                obj[col.id] = item[col.label];
              }
            });
            return obj;
          });
          console.log(payload);
          assignBulkUploadPayload(payload);
          assignIsValidated(true);
        }
      };
    },
    disabledPastDates(date) {
      let dayBefore = moment().format("YYYY-MM-DD");
      const beforeToday = new Date(dayBefore);
      beforeToday.setHours(0, 0, 0, 0);
      return date < beforeToday;
    },
    timeinminutes(time) {
      return Number(time.HH) * 60 + Number(time.mm);
    },
    handleScenarioChange(id) {
      this.resetForm();
      let current = this.scenarios.find((s) => s.id === id);
      this.is_level_applicable = true;
      if (current && current.field === 0) {
        this.is_level_applicable = false;
        this.formData.level = 1;
      }
      this.formData.file = null;
      this.formData.call_time = null;
      this.formData.isValidated = false;
      this.formData.sheetSubscribers = [];
      this.formData.subscribers = null;
      this.formData.announcement_message = null;
    },
    handleLevelChange() {
      this.resetFormData();
    },
    resetForm() {
      this.formData.level = 1;
      this.resetFormData();
    },
    resetFormData() {
      this.formData.escalationlevel = [
        {
          time: null,
          callreceivers: [],
        },
        {
          time: null,
          callreceivers: [],
        },
        {
          time: null,
          callreceivers: [],
        },
        {
          time: null,
          callreceivers: [],
        },
      ];
    },
    validateForm() {
      //  console.log(this.formData)
      let isValid = true;
      if (!this.formData.scenario) {
        isValid = false;
      }
      if (this.is_level_applicable) {
        if (!this.formData.level) {
          isValid = false;
        }
        for (let i = 0; i < this.formData.level; i++) {
          if (
            !this.formData.escalationlevel[i].time ||
            (this.formData.escalationlevel[i].time &&
              (!this.formData.escalationlevel[i].time.HH ||
                !this.formData.escalationlevel[i].time.mm)) ||
            !this.formData.escalationlevel[i].callreceivers.length
          )
            isValid = false;
        }
      } else {
        // (this.formData.subscribers && this.formData.subscribers.length) ||
        if (
          !(
            (this.formData.sheetSubscribers &&
              this.formData.sheetSubscribers.length)
          )
        ) {
          isValid = false;
        }
        if (!this.formData.call_time || !this.formData.announcement_message) {
          isValid = false;
        }
      }

      return isValid;
    },
    saveDataOn() {
      // console.log(this.formData);
      if (!this.validateForm()) {
        this.sweetAlertSnackbar(
          "Form was invalidated. Make sure that all reuired fields are filled out!",
          "error"
        );
        return;
      }
      // let timeinminutes1 =this.timeinminutes(this.formData.time.hh,this.formData.time.mm);
      //  Number(this.formData.time.hh) * 60 + Number(this.formData.time.mm);
      //  let timesforlevel4 = this.timeinminutes(this.formData.escalationlevel[3].time.hh,this.formData.escalationlevel[3].time.mm);

      let payload = {
        scenario: this.formData.scenario,
        level: this.formData.level,
        is_level_applicable: this.is_level_applicable,
      };

      if (this.is_level_applicable) {
        let escalationsload = [];

        for (let i = 0; i < this.formData.level; i++) {
          escalationsload.push({
            callreceivers: this.formData.escalationlevel[i].callreceivers,
            time: this.timeinminutes(this.formData.escalationlevel[i].time),
          });
        }
        payload.escalation = escalationsload;
      } else {
        payload.sheetSubscribers = this.formData.sheetSubscribers;
        // payload.subscribers = this.formData.subscribers;
        payload.call_time = moment(this.formData.call_time).format(
          "YYYY-MM-DD HH:mm"
        );
        payload.announcement_message = this.formData.announcement_message;
      }

      console.log(payload);

      try {
        this.isLoading = true;
        let url = `escalation/add-escalationconfig`;
        if (!this.is_level_applicable) {
          url = `/escalation/subsribers/create`;
        }
        this.makeRequest("POST", url, payload)
          .then((result) => {
            //console.log(result.data);
            this.isLoading = false;
            if (result && result.data && result.data.status) {
              this.sweetAlertSnackbar(result.data.message, "success");
              this.resetForm();
              this.formData.scenario = null;
            } else {
              this.sweetAlertSnackbar(result.data.message, "error");
            }
          })
          .catch((e) => {
            this.displayError(e);
          });
      } catch {
        this.displayError();
      }
    },
    loadtimeList() {
      this.hour_list = Array.from({ length: 25 }, (_, index) => ({
        id: index.toString(),
        label: index.toString().padStart(2, "0"),
      }));
      this.minute_list = Array.from({ length: 60 }, (_, index) => ({
        id: index.toString(),
        label: index.toString().padStart(2, "0"),
      }));
    },
    getscenarioList() {
      this.isLoading = true;
      this.searchNameMasterList(
        "ct_scenarios",
        "scenario",
        null,
        "scenario_id",
        "is_level_applicable"
      )
        .then((result) => {
          this.scenarios = result.data;
          this.isLoading = false;
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    getCallReceviers() {
      this.isLoading = true;
      this.searchNameMasterList(
        "ct_call_receivers",
        "receiver_title",
        null,
        "receiver_id"
      )
        .then((result) => {
          // console.log(result.data);
          const rawData = result.data;
          this.allcallreceivers = rawData.map((option) => ({
            id: option.label,
            label: option.label,
          }));
          this.isLoading = false;
          //console.log(this.allcallreceivers)
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    getStaffs() {
      this.isLoading = true;
      this.makeRequest("POST", "/search/getdropdowns", {
        key: "staff_id",
        label: "staff_id",
        table: "user_master",
        cond_: ` and system_name = 'CONTROL_TOWER'`,
      })
        .then((result) => {
          this.staffs = result.data.data.rows;
          this.isLoading = false;
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
  },
}

</script>
<style scoped>
    .alignment{
        margin-left: 20px;
        margin-bottom: 20px;
    }
    .requiredField {
        margin-left: 2px;
        color: red
    }
    #overlay-camera {
      position: fixed;
      display: none;
      width: 100%; 
      height: 100%; 
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0,0,0,1);
      z-index: 2; 
      cursor: pointer;
    }
    
    .overlay-camera {
      position: fixed;
      display: none;
      width: 100%; 
      height: 100%; 
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0,0,0,1);
      z-index: 2; 
      cursor: pointer;
    }
    </style>